import { IconProps } from "../types/types";

export const ArrowRightIcon = ({
  className,
  size = 20,
  onClick,
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
       
        fillRule="evenodd"
        d="m7.053 2.158 7.243 7.256a.66.66 0 0 1 .204.483.7.7 0 0 1-.204.497q-3.93 3.834-7.575 7.401c-.125.117-.625.408-1.011-.024-.386-.433-.152-.81 0-.966l7.068-6.908-6.747-6.759q-.369-.509.06-.939.43-.43.962-.04"
      />
    </svg>
  );
};
